import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "soma_token";

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  get: (p) => client.get(p).then((r) => r.data),
  post: (p, body) => client.post(p, body).then((r) => r.data),
  patch: (p, body) => client.patch(p, body).then((r) => r.data),
  del: (p) => client.delete(p).then((r) => r.data),
};

export function apiError(e) {
  return e?.response?.data?.detail || e?.message || "Something went wrong";
}
